import { ReferralAgentLinkEnum } from '~/src/models/enums/referral-agent-link.enum';

export class ReferralAgentState {
    referralAgentLink: string = '';
    stateReferralAgentLink: ReferralAgentLinkEnum = ReferralAgentLinkEnum.default;
}
